module.exports = __webpack_public_path__ + "img/ios-pint.5ff0a21d.svg";